import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from '@heroicons/react/24/solid';

const DashboardStreak = ({ streak }) => {
  if (!streak) return null;

  const weekDays = streak.week_days || [];
  const count = streak.streak || 0;

  return (
    <section className="bento-card bento-card--compact" aria-label="Your streak">
      <p className="text-label text-secondary mb-3">Your streak</p>
      <div className="flex justify-between gap-1">
        {weekDays.map((day, i) => (
          <motion.div
            key={day.date}
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.04, duration: 0.35, ease: 'easeOut' }}
            className="flex flex-col items-center gap-1.5 flex-1"
          >
            <div
              className={`w-7 h-7 rounded-full flex items-center justify-center transition-colors duration-300 ${
                day.checked_in
                  ? 'bg-pine text-bone shadow-sm'
                  : day.is_today
                    ? 'bg-bone-raised border-2 border-pine'
                    : 'bg-bone border border-hairline'
              }`}
              aria-label={day.checked_in ? 'Checked in' : day.is_today ? 'Today' : 'Not checked in'}
            >
              {day.checked_in && <CheckIcon className="w-3.5 h-3.5" />}
            </div>
            <span className="text-[10px] text-secondary font-sans">{day.label}</span>
          </motion.div>
        ))}
      </div>
      <p className={`text-body mt-3 ${count > 0 ? 'text-pine' : 'text-secondary'}`}>
        {count > 0 ? `${count}-day streak` : 'Check in daily to build your streak'}
      </p>
    </section>
  );
};

export default DashboardStreak;
